import { getDefaultReportsState } from "./state";

export default {
  setDefaultState(state) {
    // merge to keep observers in place
    Object.assign(state, getDefaultReportsState());
  },
  setEngagementTypeId(state, { engagementTypeId }) {
    state.engagementTypeId = engagementTypeId;
  },
  setIsGlobalNewslettersReport(state, { isGlobalNewslettersReport }) {
    state.isGlobalNewslettersReport = isGlobalNewslettersReport;
  },
  setTimezone(state, { timezone }) {
    state.timezone = timezone;
  },
  setEngagement(state, { engagement }) {
    state.engagement = engagement;
  },
  setPickerStartDate(state, { date }) {
    state.pickerStartDate = date;
  },
  setProductStats(state, { productStats }) {
    state.productStats = productStats;
  },
  setRecommendationProductStats(state, { recommendationProductStats }) {
    state.recommendationProductStats = recommendationProductStats;
  },
  setEngagementStatisticTypes(state, { engagementStatisticTypes }) {
    state.engagementStatisticTypes = engagementStatisticTypes;
  },
  setStatus(state, { id, value }) {
    let temp = state.headers;
    temp.find((e) => e.engagementId === id).engagementStatusId = value;
    state.headers = temp;
  },
  setPickerEndDate(state, { date }) {
    state.pickerEndDate = date;
  },
  setPickerOrderIndex(state, { index }) {
    state.pickerOrderIndex = index;
  },
  setPickerChannelType(state, { type }) {
    state.pickerChannelType = type;
  },
  setPickerEngagementMessageId(state, { id }) {
    state.pickerEngagementMessageId = id;
  },
  setIsDev(state, { isDev }) {
    state.isDev = isDev;
  },
  setAreStatsLoading(state, areStatsLoading) {
    state.areStatsLoading = areStatsLoading;
  },
  setIsTransactionalEngagement(state, { isTransactionalEngagement }) {
    state.isTransactionalEngagement = isTransactionalEngagement;
  },
  setHeaders(state, { headers }) {
    state.headers = headers;
  },
  setSelectedEngagementsStatistics(state, { stats }) {
    state.selectedEngagementsStatistics = stats;
  },
  setTrackerStatistics(state, { stats }) {
    state.trackerStatistics = stats;
  },
  setEngagementsPopularLinks(state, { links }) {
    state.engagementsPopularLinks = links;
  },
  setHide(state, { id, value }) {
    let temp = state.headers;
    temp.find((e) => e.engagementId === id).hidden = value;
    state.headers = temp;
  },
  addToSelected(state, { engagementId }) {
    if (state.selectedEngagements.length < 7) {
      state.selectedEngagements.push(engagementId);
      state.productStats = null;
    }
  },
  setSelected(state, { engagementId }) {
    let arr = [];
    if (engagementId !== null) {
      arr.push(engagementId);
    }
    state.productStats = null;
    state.selectedEngagements = arr;
  },
  removeFromSelected(state, { engagementId }) {
    let cp = state.selectedEngagements;
    var index = state.selectedEngagements.indexOf(engagementId);
    if (index > -1) {
      cp.splice(index, 1);
    }
    state.selectedEngagements = cp;
    state.productStats = null;
  },
  isLoading(state, isLoading) {
    state.isLoading = isLoading;
  },
};
